import React from "react";
import { Box, Stack, Typography, IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTranslation } from "react-i18next";
import Paragraph from "./Paragraph";

const Details = () => {
  const { t } = useTranslation();

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    console.log({
      email: data.get("email"),
      phone: data.get("phone"),
    });
  };

  return (
    <Stack
      component="section"
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        py: 10,
        px: 2,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography
          variant="h4"
          component="h3"
          sx={{
            fontWeight: 700,
            textAlign: "center",
            fontSize: { xs: "1.4rem", sm: "2.125rem" },
          }}
        >
          contact@peoplefortech.com
        </Typography>
        <Tooltip title={t("contact.copyEmail") || "Copiar email"}>
          <IconButton
            aria-label="Copiar email"
            onClick={() => navigator.clipboard && navigator.clipboard.writeText("contact@peoplefortech.com")}
            sx={{
              color: "#000000",
            }}
          >
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Stack>
      <Paragraph
        text={t("contact.contactByEmail")}
        maxWidth={"sm"}
        mx={0}
        textAlign={"center"}
      />

      <Box
        component="form"
        noValidate
        onSubmit={handleSubmit}
        sx={{
          mt: 1,
          py: 2,
        }}
      >
        {/* <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                    autoFocus
                />
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="phone"
                    label="Phone Number"
                    type="phone"
                    id="phone"
                    autoComplete="current-phone"
                />
                <Button 
                variant="contained" 
                fullWidth
                type="submit"
                size="medium"
                sx= {{ 
                    fontSize: '0.9rem',
                    textTransform: 'capitalize', 
                    py: 2,
                    mt: 3, 
                    mb: 2,
                    borderRadius: 0,
                    backgroundColor: '#14192d',
                    "&:hover": {
                        backgroundColor: '#1e2a5a',
                    }
                }}
                >
                    send
                </Button> */}
      </Box>
    </Stack>
  );
};

export default Details;
